import { Component, HostListener, inject, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslocoService } from '@jsverse/transloco'

interface Language {
  code: string
  name: string
  flag: string
}

const LANGUAGES: Language[] = [
  { code: 'en',    name: 'English',              flag: '🇺🇸' },
  { code: 'ar',    name: 'Arabic',               flag: '🇸🇦' },
  { code: 'zh-CN', name: 'Chinese (Simplified)', flag: '🇨🇳' },
  { code: 'zh-TW', name: 'Chinese (Traditional)',flag: '🇹🇼' },
  { code: 'cs',    name: 'Czech',                flag: '🇨🇿' },
  { code: 'da',    name: 'Danish',               flag: '🇩🇰' },
  { code: 'nl',    name: 'Dutch',                flag: '🇳🇱' },
  { code: 'fi',    name: 'Finnish',              flag: '🇫🇮' },
  { code: 'fr',    name: 'French',               flag: '🇫🇷' },
  { code: 'de',    name: 'German',               flag: '🇩🇪' },
  { code: 'he',    name: 'Hebrew',               flag: '🇮🇱' },
  { code: 'hi',    name: 'Hindi',                flag: '🇮🇳' },
  { code: 'id',    name: 'Indonesian',           flag: '🇮🇩' },
  { code: 'it',    name: 'Italian',              flag: '🇮🇹' },
  { code: 'ja',    name: 'Japanese',             flag: '🇯🇵' },
  { code: 'ko',    name: 'Korean',               flag: '🇰🇷' },
  { code: 'no',    name: 'Norwegian',            flag: '🇳🇴' },
  { code: 'pl',    name: 'Polish',               flag: '🇵🇱' },
  { code: 'pt',    name: 'Portuguese',           flag: '🇧🇷' },
  { code: 'es',    name: 'Spanish',              flag: '🇪🇸' },
  { code: 'sv',    name: 'Swedish',              flag: '🇸🇪' },
  { code: 'th',    name: 'Thai',                 flag: '🇹🇭' },
  { code: 'tr',    name: 'Turkish',              flag: '🇹🇷' },
  { code: 'uk',    name: 'Ukrainian',            flag: '🇺🇦' },
  { code: 'ur',    name: 'Urdu',                 flag: '🇵🇰' },
  { code: 'vi',    name: 'Vietnamese',           flag: '🇻🇳' },
]

const STORAGE_KEY = 'one_lang'

@Component({
  selector:    'one-language-switcher',
  standalone:  true,
  imports:     [CommonModule],
  templateUrl: './language-switcher.component.html',
  styleUrls:   ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {
  private translocoService = inject(TranslocoService)

  languages = LANGUAGES
  open       = false
  activeLang: Language = LANGUAGES[0]

  ngOnInit() {
    const saved = localStorage.getItem(STORAGE_KEY)
    const found = LANGUAGES.find(l => l.code === saved)
    if (found) {
      this.activeLang = found
      this.translocoService.setActiveLang(found.code)
    }
  }

  toggle() {
    this.open = !this.open
  }

  select(lang: Language) {
    this.activeLang = lang
    this.open = false
    localStorage.setItem(STORAGE_KEY, lang.code)
    this.translocoService.setActiveLang(lang.code)
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    const target = event.target as HTMLElement
    if (!target.closest('one-language-switcher')) {
      this.open = false
    }
  }
}
